"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.zrxExecuteTrade = void 0;
const web3_utils_1 = require("web3-utils");
const api_1 = require("../../../api");
const helpers_1 = require("../utils/helpers/helpers");
async function zrxExecuteTrade({ adapter }, { trade, wallet }) {
    var _a, _b, _c, _d, _e, _f;
    const { bip44Params, sellAsset } = trade;
    try {
        // value is 0 for erc20s
        const value = (0, helpers_1.isNativeEvmAsset)(sellAsset.assetId)
            ? trade.sellAmountBeforeFeesCryptoBaseUnit
            : '0';
        const buildTxResponse = await adapter.buildSendTransaction({
            value,
            wallet,
            to: trade.depositAddress,
            chainSpecific: {
                gasPrice: (0, web3_utils_1.numberToHex)(((_b = (_a = trade.feeData) === null || _a === void 0 ? void 0 : _a.chainSpecific) === null || _b === void 0 ? void 0 : _b.gasPriceCryptoBaseUnit) || 0),
                gasLimit: (0, web3_utils_1.numberToHex)(((_d = (_c = trade.feeData) === null || _c === void 0 ? void 0 : _c.chainSpecific) === null || _d === void 0 ? void 0 : _d.estimatedGas) || 0),
            },
            bip44Params,
        });
        const { txToSign } = buildTxResponse;
        const txWithQuoteData = { ...txToSign, data: (_e = trade.txData) !== null && _e !== void 0 ? _e : '' };
        if (wallet.supportsOfflineSigning()) {
            const signedTx = await adapter.signTransaction({ txToSign: txWithQuoteData, wallet });
            const txid = await adapter.broadcastTransaction(signedTx);
            return { tradeId: txid };
        }
        else if (wallet.supportsBroadcast() && adapter.signAndBroadcastTransaction) {
            const txid = await ((_f = adapter.signAndBroadcastTransaction) === null || _f === void 0 ? void 0 : _f.call(adapter, {
                txToSign: txWithQuoteData,
                wallet,
            }));
            return { tradeId: txid };
        }
        else {
            throw new api_1.SwapError('[zrxExecuteTrade]', {
                code: api_1.SwapErrorTypes.SIGN_AND_BROADCAST_FAILED,
            });
        }
    }
    catch (e) {
        if (e instanceof api_1.SwapError)
            throw e;
        throw new api_1.SwapError('[zrxExecuteTrade]', {
            cause: e,
            code: api_1.SwapErrorTypes.EXECUTE_TRADE_FAILED,
        });
    }
}
exports.zrxExecuteTrade = zrxExecuteTrade;
